import Rotas from './Routes'
import './App.css';
import { UserProvider } from './Contexts/UserContexts';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';

function App() {
  return (
    <div className="App">
      <UserProvider>
        <Rotas />
        <ToastContainer/>
      </UserProvider>
    </div>
  );
}

export default App;
